import { Link, useLocation } from 'react-router-dom';
import { CollaborationsCtx } from 'pages/MyCollaborations/contexts/collaborations-ctx';

import { useTranslation } from 'react-i18next';

import UnreadBadge from '../../UnreadBadge/UnreadBadge';

import './navbar-btns.scss';
import { useContext } from 'react';

export default function NavbarBtns({ showUnreadNotification }) {
  const location = useLocation();
  const { state } = useContext(CollaborationsCtx);

  const { t } = useTranslation('common');

  return (
    <>
      <div className="navbar__btns ml-3" style={{ gap: 8 }}>
        <Link
          to="/opportunities"
          className={`navbar__btns-btn -find mx-0 ${location.pathname === '/opportunities' ? '-is-active' : ''}`}
        >
          <span>{t('navbar_logged.desktop.find_opportunities')}</span>
        </Link>

        <div className="d-flex" style={{ gap: 8 }}>
          <Link
            to="/my_collaborations"
            className={`navbar__btns-btn mx-0 ${location.pathname === '/my_collaborations' ? '-is-active' : ''}`}
          >
            <div className="profile-menu__item">
              {t('navbar_logged.desktop.collaborations')} {state.fullUnread > 0 && <UnreadBadge isCreatorsNavbar />}
            </div>
          </Link>
          <Link
            to="/collaborations"
            className={`navbar__btns-btn mx-0 ${location.pathname === '/collaborations' ? '-is-active' : ''}`}
            id="menu_messages"
          >
            <div className="profile-menu__item">
              {t('navbar_logged.desktop.messages')} {showUnreadNotification && <UnreadBadge isCreatorsNavbar />}
            </div>
          </Link>
        </div>
      </div>
    </>
  );
}
